const ReportTemplateReformatCopyData = (listRawData) => {
  const _list = [];
  for (let rawData of listRawData) {
    const row = {};

    row["product_name"] = rawData.product_name;
    row["customer_code"] = rawData.customer_code;
    row["customer_name"] = rawData.customer_name;
    row["quantity"] = rawData.quantity;
    row["invoice_date"] = rawData.transaction_date;
    row["invoice_number"] = rawData.number;
    row["product_package_name"] = rawData.product_package_name;

    _list.push(row);
  }

  return _list;
};

export default ReportTemplateReformatCopyData;
